import { useState } from "react";
import liff from "@line/liff";

export const usePotionResetMemory = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [isError, setIsError] = useState(false);

  const resetMemory = async () => {
    setIsProcessing(true);
    setIsError(false);

    try {
      await liff.sendMessages([{ type: "text", text: "**reset**" }]);
      liff.closeWindow();
    } catch (error) {
      setIsError(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const clearError = () => {
    setIsError(false);
  };

  return { resetMemory, isProcessing, isError, clearError };
};

export default usePotionResetMemory;
